import {
  type FC,
  forwardRef,
  type PropsWithChildren,
  type ReactNode,
} from 'react';
import CloseIcon from '@assets/img/icons/close-v2.svg?react';
import cn from 'classnames';
import { type HTMLMotionProps, motion } from 'framer-motion';

import { opacityAnimation } from '@/common/config/motion-animations';
import { Button } from '@/components/ui/Button/Button';

import css from './styles.module.scss';

interface OverlayModalProps
  extends Partial<Omit<HTMLMotionProps<'div'>, 'children'>>,
    PropsWithChildren {
  closeButton?: () => ReactNode;
  onClose?: () => void;
}

const OverlayModal: FC<OverlayModalProps> = forwardRef<
  HTMLDivElement,
  OverlayModalProps
>(({ children, closeButton, onClose, ...props }, ref) => {
  return (
    <motion.div
      ref={ref}
      {...opacityAnimation}
      {...props}
      className={cn(css.overlayModal, props.className)}
    >
      {children}
      {closeButton ? (
        closeButton()
      ) : (
        <Button
          variant="transparent"
          className="absolute left-1/2 -translate-x-1/2 bottom-16 !w-16 !h-16"
          onClick={onClose}
        >
          <CloseIcon className="aspect-square w-full" />
        </Button>
      )}
    </motion.div>
  );
});

export { OverlayModal };
